import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { Report, ReportType, SelectOption } from '@features/active/models';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, retry } from 'rxjs/operators';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
const BASE_PATH = environment.basePathExternal

const basePathExternalApi = environment.basePathExternalApi

import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { HttpUrlEncodingCodec } from '@app/core/services/auth/encoder';

@Injectable({
  providedIn: 'root',
})
export class ActiveService {
  constructor(
    protected httpClient: HttpClient,
    private snackBarService: DialogBoxService,
    private shared: SharedVariable,
    private encoder: HttpUrlEncodingCodec
  ) {}

   fileList : any[] = []

  getPortfolioGroups(): Observable<SelectOption[]> {
    return of([
      { code: 'FTSE 250', name: 'FTSE 250' },
      { code: 'Vanguard Emerging Markets', name: 'Vanguard Emerging Markets' },
      { code: 'United Utilities', name: 'United Utilities' },
      { code: 'BHP Group', name: 'BHP Group' },
      { code: 'PTF-997', name: 'PTF-997' },
    ])
  }

  getReports(): Observable<Report[]> {
    return of([
      {
        code: 'Fixed Income Operation Blocking - Per movement',
        name: 'Fixed Income Operation Blocking - Per movement',
        type: 'Movement',
      },
      { code: 'Daily Portfolio', name: 'Daily Portfolio', type: 'Position' },
      { code: 'Temporary Movement', name: 'Temporary Movement', type: 'Position' },
      {
        code: 'Detailed Fixed Income Stock',
        name: 'Detailed Fixed Income Stock',
        type: 'Movement',
      },
      { code: 'Cash flow', name: 'Cash flow', type: 'Movement' },
      {
        code: 'SWAP Calculation Memory',
        name: 'SWAP Calculation Memory',
        type: 'Movement',
      },
      { code: 'cash statement', name: 'Cash statement', type: 'Movement' },
      {
        code: 'Dividends  Appropriate Interest',
        name: 'Dividends  Appropriate Interest',
        type: 'Movement',
      },
      {
        code: 'Quota Evolution Map',
        name: 'Quota Evolution Map',
        type: 'Movement',
      },
      {
        code: 'Movement of Share Term',
        name: 'Movement of Share Term',
        type: 'Movement',
      },
      {
        code: 'Movement of Stock Loans',
        name: 'Movement of Stock Loans',
        type: 'Movement',
      },
      { code: 'Futures Movement', name: 'Futures Movement', type: 'Movement' },
      {
        code: 'Ticket Movement and Withdrawal',
        name: 'Ticket Movement and Withdrawal',
        type: 'Movement',
      },
      { code: 'SWAP movement', name: 'SWAP movement', type: 'Movement' },
      {
        code: 'Fixed Income Settlement Note',
        name: 'Fixed Income Settlement Note',
        type: 'Movement',
      },
      {
        code: 'Variable Income Blocking Operations',
        name: 'Variable Income Blocking Operations',
        type: 'Movement',
      },
      {
        code: 'Investment Fund Transactions',
        name: 'Investment Fund Transactions',
        type: 'Movement',
      },
      {
        code: 'Fixed Income Securities Transactions',
        name: 'Fixed Income Securities Transactions',
        type: 'Movement',
      },
      {
        code: 'Transactions with Variable Income Securities',
        name: 'Transactions with Variable Income Securities',
        type: 'Movement',
      },
      {
        code: 'Blocked Position of Fund Quotas',
        name: 'Blocked Position of Fund Quotas',
        type: 'Movement',
      },
      {
        code: 'Locked Position of Variable Income Papers',
        name: 'Locked Position of Variable Income Papers',
        type: 'Position',
      },
      {
        code: 'Calculation Memory - All rate types',
        name: 'Calculation Memory - All rate types',
        type: 'Movement',
      },
      { code: 'Other Values', name: 'Other Values', type: 'Movement' },
      {
        code: 'Equity Loan Position',
        name: 'Equity Loan Position',
        type: 'Position',
      },
      { code: 'Futures Position', name: 'Futures Position', type: 'Position' },
      { code: 'SWAP position', name: 'SWAP position', type: 'Position' },
      { code: 'Composition of the Fund Portfolio', name: 'Composition of the Fund Portfolio', type: 'Position' },
      { code: 'Simplified Extract', name: 'Simplified Extract', type: 'Movement'},

      { code: 'Futures Inventory Report', name: 'Futures Inventory Report', type: 'Movement'},
      { code: 'RV Stock Report', name: 'RV Stock Report', type: 'Movement'},
      { code: 'RF Stock Report', name: 'RF Stock Report', type: 'Movement'},
      { code: 'Fund Cota Holding', name: 'Fund Cota Holding', type: 'Movement'},
      { code: 'Book SAT', name: 'Book SAT', type: 'Others' },
      { code: 'Book SAC', name: 'Book SAC', type: 'Others' },
    ])
  }

  getReportTypes(): Observable<ReportType[]> {
    return of([
      { code: 'Position', name: 'Position' },
      { code: 'Mouvement', name: 'Mouvement' },
      { code: 'Other', name: 'Other' }
    ])
  }

  getReportByreportType(reportType):any{
    if(reportType !== '')
    return this.httpClient.get<any>(
      `${BASE_PATH}/report/getReportsFromType/${reportType}`
    )

  }



  fromToDateValidator(
    fromDateField: string,
    toDateField: string,
    errorName: string = 'fromToDate'
  ): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const fromDate = formGroup.get(fromDateField).value
      const toDate = formGroup.get(toDateField).value
      if (fromDate !== null && toDate !== null && fromDate > toDate) {
        return { [errorName]: true }
      }
      return null
    }
  }

  /**
   * Generating XML anbima
   * @param body
   * @returns
   */
  generateXmlReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
     let result = this.httpClient.post<any>(
      `${basePathExternalApi}/xmlanbimageneration`,
      body,
      { headers: headers }
    )
    return result;
  }

  /**
   * generating XMLs compressed
   * @param funds
   * @param res
   * @param zipName
   */
   createZip(funds:any,res: any[],fileName, zipName: string) {
    const zip = new JSZip();

    let count = 0;
    for(let i =0; i< res.length; i++) {
        const name = res[i].name;
        
        zip.file(name, res[i].connectionID);
        count++;
    }
    let fileZip = fileName
        //fileZip = fileZip.slice(0, -3) + "zip"
        fileZip = fileZip
    if(count == res.length) {
      zip.generateAsync({ type: 'blob' }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, fileZip);
      }
    });
    }
    this.shared.fileListAnbimaForZip = []
  }

  formatDate (date){
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  /**
   * download xml file from api
   * @param res
   * @param body
   */
  downloadXml(funds:any,res: any,fileName) {
    const contentType = { type: "application/xml" };
    console.log('contentType', contentType);
    for(let i=0; i< res.length;i++) {
      const blob = new Blob([res[i]])
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      this.shared.fileListAnbima = []
    }


    // document.body.removeChild(link);
  }
  generateCarteiraDiariaReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateCarteiraDiaria`,
      body,
      { headers: headers }
    )
  }
  generateMovimentoTransitorio(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateMovimentoTransitorio`,
      body,
      { headers: headers }
    )
  }
  generateBookSacReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSAC`,
      body,
      { headers: headers }
    )
  }
  generateBookSatReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSAT`,
      body,
      { headers: headers }
    )
  }
    generateBookSatSamReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSATSAM`,
      body,
      { headers: headers }
    )
  }
  generateReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateReport`,
      body,
      { headers: headers }
    )
  }
  generateReportAsync(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateQlikReportAsync`,
      
      body,
      { headers: headers }
    )
  }
  downloadReport(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/downloadReport`,
      body,
      { headers: headers }
    )
  }

  getAllFundGroup(){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/getAllFundGroupByUserType`,null,{ headers: headers });
  }

  getFundListByFundGroupId(id){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/getFundsByGroup`,
      id,
      { headers: headers }
    ).pipe(
      map((groups) => (groups || []).flatMap((group: any) => group.groupingByFund || []))
    )
  }

  createFundGroup(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/groupOfFunds/save`,
      body,
      { headers: headers }
    )
  }

  editFundGroup(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.put<any>(
      `${BASE_PATH}/groupOfFunds`,
      body,
      { headers: headers }
    )
  }

  getFundGroupById(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/groupOfFunds/${id}`
    ) .pipe(retry(5), catchError(null));
  }
  deleteFundGroup(code): Observable<any> {
    return this.httpClient.delete<any>(
      `${BASE_PATH}/groupOfFunds/${code}`)
  }


  // getReportFundByFundGroupId(id){
  //   if (id === null || id === undefined) {
  //     return throwError('Required parameter id was null or undefined.');
  //   }
  //   return this.httpClient.get<any>(
  //     `${BASE_PATH}/reportFunds/search?criteria=groupoffund==${id}`
  //   ) .pipe(retry(5), catchError(null));
  // }

  getReportsFund() {
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportFunds/search`
    ).pipe(retry(5), catchError(null));
  }

  getAllSchedulingReports(): Observable<any[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/getAllAgendamentoByUserType`,null, { headers: headers }
    )
  }
  createSceduling(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/reportingJobConfigs`,
      body,
      { headers: headers }
    )
  }

  editSceduling(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.put<any>(
      `${BASE_PATH}/reportingJobConfigs`,
      body,
      { headers: headers }
    )
  }

  deleteSchedulingReport(code): Observable<any> {
    return this.httpClient.delete<any>(
      `${BASE_PATH}/reportingJobConfigs/${code}`)
  }

  getSchedulingReportById(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}`
    ) .pipe(retry(5), catchError(null));
  }
  getSchedulingFrequencyById(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/frequency`
    ) .pipe(retry(5), catchError(null));

  }
  getSchedulingGroupOfFundById(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/groupoffund`
    ) .pipe(retry(5), catchError(null));

  }
  getReportMailById(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/reportMail`
    ) .pipe(retry(5), catchError(null));

  }
  getReportJobs(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/reportJobs`
    ) .pipe(retry(5), catchError(null));

  }
  getReportingJobFunds(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/reportingJobFunds`
    ) .pipe(retry(5), catchError(null));

  }

  getDaysOfWeek(id){
    if (id === null || id === undefined) {
      return throwError('Required parameter id was null or undefined.');
    }
    return this.httpClient.get<any>(
      `${BASE_PATH}/reportingJobConfigs/${id}/dayOfWeek`
    ) .pipe(retry(5), catchError(null));

  }

  getSetteledOperationsCount(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/countTransactionsByProductType`,
      body,
      { headers: headers }
    )
  }
generateBookSACAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSACAsync`,
      body,
      { headers: headers }
    )
  }
  generateCarteiraDiariaAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateCarteiraDiariaAsync`,
      body,
      { headers: headers }
    )
  }
  generateMovimentoTransitorioAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateMovimentoTransitorioAsync`,
      body,
      { headers: headers }
    )
  }
  generateBookSATAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSATAsync`,
      body,
      { headers: headers }
    )
  }
   generateBookSATSAMAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateBookSATSAMAsync`,
      body,
      { headers: headers }
    )
  }
    // findReportRequests(criteria?: String, order?: string, keys?: string): Observable<any[]> {
    //   let params = new HttpParams()
    //   if (criteria !== undefined && criteria !== null) {
    //     params = params.append(
    //       'criteria',
    //       this.encoder.encodeValue(criteria.toString())
    //     )
    //   }
 
    //   return this.httpClient.get<any[]>(
    //     `${BASE_PATH}/reportRequests/search`,
    //     { params: params }
    //   )
    // }
    findReportRequests(criteria?: string, order?: string, keys?: string): Observable<any[]> {
  let params = new HttpParams();
  if (criteria !== undefined && criteria !== null) {
    params = params.append('criteria', criteria);
  }
  
  return this.httpClient.get<any[]>(
    `${BASE_PATH}/reportRequests/search`,
    { params: params }
  );
}
  downloadReportAsync(body) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/downloadReportAsync`,
      body,
      { headers: headers }
    )
  }

  generatePosicaoTitulos(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generatePosicaoTitulos`,
      body,
      { headers: headers }
    )
  }

  generatePosicaoTitulosAsync(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generatePosicaoTitulosAsync`,
      body,
      { headers: headers }
    )
  }

    generateMovimentoCambio(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateMovimentoCambio`,
      body,
      { headers: headers }
    )
  }
    generateMovimentoCambioAsync(body){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateMovimentoCambioAsync`,
      body,
      { headers: headers }
    )
  }

  generateQlikAsynFromAzureStorage(body: { requestId: string }) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.post<any>(
      `${BASE_PATH}/report/generateQlikAsynFromAzureStorage`,
      body,
      { headers: headers }
    )
  }
}
